// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ClockCircleFilledSvg from "@ant-design/icons-svg/es/asn/ClockCircleFilled";
import AntdIcon from '../components/AntdIcon';

var ClockCircleFilled = function ClockCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ClockCircleFilledSvg
  }));
};

ClockCircleFilled.displayName = 'ClockCircleFilled';
export default React.forwardRef(ClockCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ClockCircleFilled.js
// module id = 777
// module chunks = 0